module.exports = __webpack_public_path__ + "static/media/bnr_kei2e0242cfc0265766fee03d365fdefd6e.webp";